export const stringsKey = "GroupDetailTablePreview";
export const englishStrings = {
	genericSelectColumnLabel: "Select Column with",
	selectPhoneColumnLabel: "Select Column with Phone Numbers",
	tableHeaderIncludedLabel: "Exclude Table Header",
	missingVariables: `
		Missing variable assignments. Select a column or the variable placeholder will be replaced with an empty string.`,
};
